import { useState } from 'react';
import { useReactTable, getCoreRowModel, createColumnHelper } from '@tanstack/react-table';

import Table from '../../Components/Table/Table';
import { Page } from '../../Components/Page/Page.component';
import { Button } from '../../Components/Button/Button';

import { useExerciseTypesContext } from '../../Contexts/ExerciseTypes.Context';
import { Exercise } from '../../Clients/reminds';
import { Remove } from '../../Icons/Remove';
import { AddExerciseTypeModal } from './AddExerciseTypeModal';

const columnHelper = createColumnHelper<Exercise>();

const defaultColumns = [
  columnHelper.accessor('name', {
    header: 'Name',
  }),
  columnHelper.accessor('notes', {
    header: 'Notes',
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: props => {
      return <DeleteButton id={props.row.original.id} />;
    },
  }),
];

export const SettingsPage = () => {
  const { data, addExerciseType } = useExerciseTypesContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const table = useReactTable({
    data,
    columns: defaultColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  console.log('Rendering');

  return (
    <Page title="Settings">
      <h2 style={{ marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600, color: '#f0f0f0' }}>Exercise Types</h2>
      <Table table={table}></Table>
      <Button onClick={() => setIsModalOpen(true)}>Add</Button>

      <AddExerciseTypeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={addExerciseType} />
    </Page>
  );
};

const DeleteButton: React.FC<{ id: number | undefined }> = ({ id }) => {
  const { deleteExerciseType } = useExerciseTypesContext();

  const handleDelete = () => {
    if (id) deleteExerciseType(id);
  };

  return <Remove onRemove={handleDelete} />;
};
